import { plural } from '../speak';

/** The page as JSON: its view, the state of the text, what each problem is, and the mistakes a person makes typing JSON. */
export const json = {
  pageAsJson: 'The page as JSON',
  copyJson: 'Copy JSON',
  apply: 'Apply',
  discard: 'Discard',
  keepEditing: 'Keep editing',
  notApplied: 'The changes typed here are not applied yet.',
  problems: 'Problems',
  hint: (chord: string) => `Tab indents. To leave the box, press Esc, then Tab. ${chord}Enter applies.`,
  severity: { error: 'Cannot apply', must: 'Must fix', should: 'Should fix' },
  goToLine: (line: number, column: number) => `Go to line ${line}, column ${column}`,
  line: (line: number) => `Line ${line}`,
  toPutRight: (n: number) => `${plural('en', n, { one: '# problem', other: '# problems' })} to put right before this can be applied.`,
  changed: (chord: string) => `Changed here, not applied yet: Apply or ${chord}Enter.`,
  nothingToApply: 'Nothing to apply: the text is the page as it is.',
  cannotFix: 'That fix cannot be made in the text as it is.',
  fixed: 'Fixed in the text. Apply to keep it.',
  applied: 'Applied. Undo takes it back.',
  copied: 'Copied.',
  selected: (chord: string) => `Selected: press ${chord}C to copy.`,
  /** A problem the page's format finds, in the format's own words (English): said as they are. */
  formatProblem: (message: string) => message,
  editAsJson: 'Edit the page as JSON',
  backToDesigning: 'Back to designing',
  /** The mistakes in the text itself, as the box reads it. */
  mistakes: {
    anyValue: 'This is not a value JSON knows: text in double quotes, a number, true, false, null, [ … ] or { … }',
    endsTooSoon: (wanted: string) => `The text ends too soon: ${wanted}`,
    valueMissing: 'a value is missing',
    closingMissing: (close: string) => `a closing ${close} is missing`,
    noComments: 'JSON has no comments',
    doubleQuotes: 'Text goes in double quotes',
    noClosingQuote: 'This text has no closing double quote',
    lineBreak: 'A line break cannot sit inside text: write \\n',
    controlCharacter: 'A control character cannot sit inside text',
    escape: (escape: string) => `"\\${escape}" is not something JSON knows: write \\\\ for a backslash`,
    extraZeros: 'A number cannot start with extra zeros',
    nothingAfterComma: 'Nothing follows this comma: take it away',
    commaMissing: 'A comma is missing before this',
    commaOrClosing: (close: string) => `A comma or a closing ${close} is missing here`,
    keyQuotes: (word: string) => `A key goes in double quotes, such as "${word}"`,
    colonMissing: 'A colon is missing after the key',
    empty: 'The box is empty: a page is a JSON object, { … }',
    moreAfterEnd: 'There is more after the end: one { … } is the whole page',
  },
};
